import './GaugeVisualization.scss';

export { schema, uiSchema, getSchema } from '../../schemas/GaugeVisualizationSchema';

export { default } from './GaugeVisualization';
